import React from 'react';
import Dropzone from 'react-dropzone';
import Button from '../Button';
import PropTypes from 'prop-types';

// for profile picture
class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      files: this.props.files,
    };
  }

  componentWillUnmount() {
    // Make sure to revoke the data uris to avoid memory leaks
    if (!!this.state.files[0]) this.state.files.forEach((file) => URL.revokeObjectURL(file.preview));
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.files !== this.props.files)
      // console.log(!!this.props.files[0]);
      this.setState({
        hasError: !!this.props.files[0],
        files: this.props.files,
      });
  };

  onDrop = (accepted, rejected) => {
    if (Object.keys(rejected).length !== 0) {
      const message = 'Please submit valid file type';
      this.setState({ warningMsg: message });
    } else {
      this.props.addFile(accepted);
      this.setState({ warningMsg: '' });

      var blobPromise = new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        reader.readAsDataURL(accepted[0]);
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data);
        };
      });
      blobPromise.then((value) => {
        // console.log(value);
      });
    }
  };
  render() {
    const { files } = this.props;
    return (
      <div className="fui-dropzone">
        <Dropzone onDrop={this.onDrop} multiple={false} accept='.docx,.pptx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .pdf'>
          {({ getRootProps, getInputProps }) => (
            files[0] === null ? <div {...getRootProps()}>
              <input {...getInputProps()} name={this.props.name} accept='.docx,.pptx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .pdf' />
              {!!files[0] ? (
                <div className='upload-preview'>
                  {this.state.hasError ? (
                    <span className='error'>
                      <i className='icon-error'></i>
                      <span className='text'>{'圖片無法辨識，可能是因為反光、陰影、圖片歪斜遮住了證件內容。'}</span>
                    </span>
                  ) : (
                      <span className='check'>
                        <i className='icon-check'></i>
                      </span>
                    )}
                  <button className='fui-button is-secondary' onClick={this.triggerModal}>刪除檔案</button>
                </div>
              ) : (
                  <div className='upload-description'>
                    <img src={'/resources/common/images/upload@2x.png'} width='120' alt='upload' />
                    <p>拖曳檔案到灰色區域或點擊這裡選擇檔案</p>
                    <Button btnStyle='secondary'>上傳檔案</Button>
                  </div>
                )}
            </div> : <div>
                <div className='upload-preview'>
                  <span className='check'>
                    <i className='icon-check'></i>
                  </span>
                  {files[0].type === 'application/pdf' ? <img src={'/resources/common/images/file-pdf.svg'} width='120' alt='pdf' /> : null}
                  {files[0].name.indexOf('.doc') > 0 ? <img src={'/resources/common/images/file-word.svg'} width='120' alt='word' /> : null}
                  {files[0].name.indexOf('.xls') > 0 ? <img src={'/resources/common/images/file-excel.svg'} width='120' alt='excel' /> : null}
                  {files[0].name.indexOf('.ppt') > 0 ? <img src={'/resources/common/images/file-ppt.svg'} width='120' alt='ppt' /> : null}
                  <p style={{ wordBreak: 'break-all' }} className='m-0 is-text-gray100' style={{ height: 56 }}>{files[0].name} | {(files[0].size / 1024).toFixed(2)} KB</p>
                  <Button onClick={() => { this.props.deleteFile() }} btnStyle='secondary'>刪除檔案</Button>
                </div>
              </div>
          )}
        </Dropzone>
      </div>
    );
  }
}

ImageUpload.propTypes = {
  name: PropTypes.string,
  files: PropTypes.array,
  addFile: PropTypes.func,
};

export default ImageUpload;
